import { generatePath } from 'react-router-dom';
import Api from '@/domain/api';

import ROUTES_PATH from '@/router/routesPathConfig';

export function getPaymentUrl(companyId: string, paymentId: string): string {
  return generatePath(ROUTES_PATH.PAY_PAYMENT.absolute, {
    companyId,
    paymentId,
  });
}

export function getPaymentPreviewSrc(companyId: string, paymentId: string): string {
  return Api.getPaymentThumbnailUrl({
    companyId,
    paymentId,
  });
}
